<template>
    <div class="card">
        <h5>{{ $t('menu.lsportsLocations') }}</h5>
        <SportEntities :entityType="'location'"></SportEntities>
    </div>
</template>
<script>
import SportEntities from './SportEntities.vue';
export default {
    name: 'lsportsSports',
    components: {
        SportEntities,
    },
    data() {
        return {};
    },
};
</script>
